/**
 * Textarea Control Component
 * Renders multiline text area
 */

import React from 'react';
import { Box } from '@mui/material';
import { ControlComponentProps } from '../../../../types/ControlTypes';
import { TextareaSettings } from '../../../../types/ControlTypes';
import { BaseTextField } from '../BaseTextField';
import { LabelWithInfo } from './LabelWithInfo';

export const TextareaControl: React.FC<ControlComponentProps> = ({
  name,
  value,
  onChange,
  error,
  disabled,
  readonly,
  label,
  placeholder,
  description,
  control,
  required,
}) => {
  const settings = control.settings as TextareaSettings;
  const rows = settings?.rows || 4;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ mb: 1 }}>
        <LabelWithInfo
          label={label || name}
          description={description || placeholder}
          required={required}
        />
      </Box>
      <BaseTextField
        multiline
        rows={rows}
        value={typeof value === 'string' ? value : ''}
        onChange={handleChange}
        placeholder={placeholder || settings?.placeholder}
        size="small"
        fullWidth
        disabled={disabled || readonly}
        error={!!error}
        helperText={error || (settings?.maxLength ? `${(value || '').length}/${settings.maxLength}` : '')}
        inputProps={{
          maxLength: settings?.maxLength,
          minLength: settings?.minLength,
        }}
      />
    </Box>
  );
};

export default TextareaControl;
